import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { useNavigate } from 'react-router-dom';

import ClockIcon from '@mui/icons-material/AccessTime';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import HideIcon from '@mui/icons-material/Visibility';
import MoneyIcon from '@mui/icons-material/Paid';
import PinIcon from '@mui/icons-material/PushPin';
import PlaceIcon from '@mui/icons-material/Place';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import ShowIcon from '@mui/icons-material/VisibilityOff';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Stack from '@mui/material/Stack';

import {getSessionTypeUrl} from '../../helpers/sessionTypes';
import {formatCurrency} from '../../helpers/currency';
import ListSessionTypesCard from "./ListSessionTypesCard";
import config from "../../config/config";

const parseLocation = sessionType => {
  if (sessionType?.location_type === 'VIRTUAL') return 'Virtual';
  if (sessionType?.location_type === 'HOME') return 'Patient Home';
  if (sessionType?.location_type === 'OTHER_MOBILE') return 'Other Mobile';
  let str = sessionType.address_line_1 ? `${sessionType.address_line_1 } ` : '';
  str += `${sessionType.address_line_2}`;
  str += ', ';
  str += sessionType.address_city;
  str += ', ';
  str += sessionType.address_state;
  str += ' ';
  str += sessionType.address_zip;
  return str;
};

const getRows = sessionType => {
  const rowData = [
    {
      Icon: PlaceIcon,
      text: <>{parseLocation(sessionType)}</>,
    },
    {
      Icon: ClockIcon,
      text: <>{`${sessionType.duration_minutes} minutes`}</>,
    },
    {
      Icon: MoneyIcon,
      text: <>{`${formatCurrency(sessionType.hourly_rate)}/hour`}</>,
    },
  ];
  return rowData;
};

const SessionTypeListItem = props => {
  const sessionTypeLink = `/session-types/${props?.sessionType?.id}`;
  const listItems = getRows(props.sessionType);
  const navigate = useNavigate();
  const menuItems = [
    {
      children: <><DeleteIcon style={{marginRight: '0.25em', color: config().colors.primary}}/> Delete</>,
      onClick: props.onDelete,
    },
  ];
  const buttons = [
    {
      children: 'Edit',
      onClick: () => navigate(sessionTypeLink),
    },
    (
      props.sessionType.hide_from_patients
      ? {
        children: <><ShowIcon style={{fontSize: 'large', marginRight: '0.2em'}}/> Show</>,
        onClick: props.onShow,
      }
      : {
        children: <><HideIcon style={{fontSize: 'large', marginRight: '0.2em'}}/> Hide</>,
        onClick: props.onHide
      }
    )
  ];
  return (
    <ListSessionTypesCard
      key={props.sessionType.id}
      color={props.sessionType.css_color}
      title={
        <Stack direction='row' alignItems='center' gap={0.25}>
          {props.sessionType?.pinned && <PinIcon style={{color: config().colors.gray, fontSize: '1.5em'}} />}
          {props.sessionType?.is_discovery_session && <NewReleasesIcon style={{color: config().colors.gray, fontSize: '1.5em'}} />}
          {props.sessionType.title}
        </Stack>
      }
      listItems={listItems}
      menuItems={menuItems}
      buttons={buttons}
    />
  );
};

SessionTypeListItem.propTypes = {
  sessionType: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onShow: PropTypes.func,
  onHide: PropTypes.func,
};

export default SessionTypeListItem;
